module.exports = __webpack_public_path__ + "static/media/pattern-africa.f3c827dd.png";